"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/** SiteSurveyMixin class */
var SiteSurveyMixin = /** @class */ (function () {
    function SiteSurveyMixin() {
    }
    /**
     * getSiteSurvey
     * @param siteSurveyId
     * @param callback
     */
    SiteSurveyMixin.prototype.getSiteSurvey = function (agencyId, siteSurveyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.FullSiteSurvey.parse));
        };
        this.http.get("/agencies/" + agencyId + "/site-surveys/" + siteSurveyId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * searchSiteSurvey
     * @param query
     * @param agencyId
     * @param latitude
     * @param longitude
     * @param maxDistance
     * @param callback
     */
    SiteSurveyMixin.prototype.searchSiteSurveys = function (query, agencyId, latitude, longitude, maxDistance, page, limit, callback) {
        var _this = this;
        var params = {};
        if (query)
            params.query = query;
        if (latitude !== null)
            params.latitude = latitude;
        if (longitude !== null)
            params.longitude = longitude;
        if (maxDistance !== null)
            params.maxDistance = maxDistance;
        params.page = page;
        params.limit = limit;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) {
                return models_1.PageResult.parse(o, 'surveys', models_1.MinimalSiteSurvey.parse);
            }));
        };
        this.http.get("/agencies/" + agencyId + "/site-surveys", params, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * addSiteSurvey
     * @param agencyId
     * @param address
     * @param critical
     * @param advisories
     * @param informationals
     * @param location
     */
    SiteSurveyMixin.prototype.addSiteSurvey = function (agencyId, address, expirationTs, critical, advisories, informationals, location, callback) {
        var _this = this;
        var body = {
            address: address,
            critical: critical ? critical.toJson() : critical,
            advisories: advisories,
            informationals: informationals,
            expirationTs: expirationTs ? expirationTs.toISOString() : null,
            location: location,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.MinimalSiteSurvey.parse));
        };
        this.http.post("/agencies/" + agencyId + "/site-surveys", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * editSiteSurvey
     *
     * @param siteSurveyId
     * @param address
     * @param critical
     * @param advisories
     * @param location
     */
    SiteSurveyMixin.prototype.editSiteSurvey = function (agencyId, siteSurveyId, address, expirationTs, critical, location, callback) {
        var _this = this;
        var body = {
            address: address,
            critical: critical,
            expirationTs: expirationTs,
            location: location,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/site-surveys/" + siteSurveyId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * deleteSiteSurvey
     * @param siteSurveyId
     */
    SiteSurveyMixin.prototype.deleteSiteSurvey = function (agencyId, siteSurveyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/site-surveys/" + siteSurveyId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * addSiteSurveyValue
     * @param surveyId
     * @param type
     * @param value
     * @param callback
     */
    SiteSurveyMixin.prototype.addSiteSurveyValue = function (agencyId, surveyId, type, value, callback) {
        var _this = this;
        var body = value.toJson();
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SiteSurveyValue.parse));
        };
        this.http.post("/agencies/" + agencyId + "/site-surveys/" + surveyId + "/" + type, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * editSiteSurveyValue
     * @param agencyId
     * @param surveyId
     * @param surveyValueId
     * @param type
     * @param url
     * @param value
     * @param callback
     */
    SiteSurveyMixin.prototype.editSiteSurveyValue = function (agencyId, surveyId, surveyValueId, type, url, value, callback) {
        var _this = this;
        var expirationTsEdit = value.expirationTs ? models_1.Editable.set(value.expirationTs) : models_1.Editable.clear();
        var body = {
            type: value.type,
            key: value.key,
            text: value.text,
            expirationTs: expirationTsEdit,
        };
        if (value instanceof models_1.SiteSurveyValueFile) {
            body.fileId = value.fileId;
        }
        if (value instanceof models_1.SiteSurveyValueLink) {
            body.url = value.url;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/site-surveys/" + surveyId + "/" + type + "/" + surveyValueId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * deleteSiteSurveyValue
     * @param surveyId
     * @param surveyValueID
     * @param type
     * @param callback
     */
    SiteSurveyMixin.prototype.deleteSiteSurveyValue = function (agencyId, surveyId, surveyValueID, type, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/site-surveys/" + surveyId + "/" + type + "/" + surveyValueID, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return SiteSurveyMixin;
}());
exports.default = SiteSurveyMixin;
//# sourceMappingURL=SiteSurveyMixin.js.map